<st-view-state>
    <div class="st-cast-view-state-header">
        <st-text-area-overlay
            class="st-cast-view-state-header__title"
            minHeight="2rem"
            panelClass="st-cast-view-state-header__title"
            [value]="viewStateTitle$ | ngrxPush"
            [placeholder]="languageSettings.PSTWebAddViewTitleLabel"
            [required]="true"
            (changed)="updateTitle($event)" />
    </div>
    <div class="st-cast-view-state-body">
        <div class="st-cast-view-state-body-tile">
            <div class="st-cast-view-state-body__type-content">
                <span class="st-cast-view-state-body__type-content__label">{{ languageSettings.PSTWebContentTypeLabel }}</span>
                <st-check-box
                    [value]="viewStateShowTopics()"
                    [label]="languageSettings.PSTWebPublicationChannelShowTopics"
                    (changed)="updateShowTopics($event)" />
                <st-check-box
                    [value]="viewStateShowAssignments()"
                    [label]="languageSettings.PSTWebPublicationChannelShowAssignments"
                    (changed)="updateShowAssignments($event)" />
            </div>
        </div>

        <div class="st-cast-view-state-body-default-layout">
            <span class="st-cast-view-state-body-default-layout__label"> {{ languageSettings.PSTWebDefLayoutLabel }} </span>
            <button
                mat-stroked-button
                [matMenuTriggerFor]="layoutMenu">
                {{ viewStateLayout()?.Label }} {{ languageSettings.PSTWebViewLabel }}
            </button>
            <mat-menu #layoutMenu="matMenu">
                <mat-selection-list
                    hideSingleSelectionIndicator
                    [multiple]="false"
                    (selectionChange)="updateLayout(viewStateLayout(), $event?.options?.[0]?.value)">
                    <mat-list-option
                        *ngFor="let option of viewStateLayout()?.Options"
                        [value]="option.id">
                        <div
                            matListItemTitle
                            [dir]="isRTL">
                            {{ option.title }}
                        </div>
                    </mat-list-option>
                </mat-selection-list>
            </mat-menu>
        </div>

        <div class="st-cast-view-state-body-default-view">
            <span class="st-cast-view-state-body-default-view__label">{{ languageSettings.PSTWebDefaultViewLabel }}</span>
            <button
                mat-stroked-button
                [matMenuTriggerFor]="viewMenu">
                {{ selectedDefaultView$ | ngrxPush }}
            </button>
            <mat-menu #viewMenu="matMenu">
                <mat-selection-list
                    hideSingleSelectionIndicator
                    [multiple]="false"
                    (selectionChange)="updateViewStateGUID($event?.options?.[0]?.value)">
                    <mat-list-option
                        *ngFor="let view of playbookViewStateRecords()"
                        [value]="view.guid">
                        <div
                            matListItemTitle
                            [dir]="isRTL">
                            {{ view.title }}
                        </div>
                    </mat-list-option>
                </mat-selection-list>
            </mat-menu>
        </div>

        <div class="st-cast-view-state-body-channel">
            <span class="st-cast-view-state-body-channel__label">{{ languageSettings.PSTWebNPCHLabel }}</span>
            <button
                mat-stroked-button
                [matMenuTriggerFor]="channel">
                {{ selectedPublicationChannel() }}
            </button>
            <mat-menu #channel="matMenu">
                <mat-selection-list
                    hideSingleSelectionIndicator
                    [multiple]="false"
                    (selectionChange)="updatePublicationChannelGUID($event?.options?.[0]?.value)">
                    <mat-list-option
                        *ngFor="let channel of publicationChannelRecords()"
                        [value]="channel.Guid">
                        <div
                            matListItemTitle
                            [dir]="isRTL">
                            {{ channel.Title }}
                        </div>
                    </mat-list-option>
                </mat-selection-list>
            </mat-menu>
        </div>

        <div class="st-cast-view-state-body-edition">
            <span class="st-cast-view-state-body-edition__label"> {{ languageSettings.PSTWebPublicationChannelEditionName }} </span>
            <button
                mat-stroked-button
                [matMenuTriggerFor]="editionMenu">
                {{ selectedEditionName$ | ngrxPush }}
            </button>
            <mat-menu #editionMenu="matMenu">
                <mat-selection-list
                    hideSingleSelectionIndicator
                    [multiple]="false"
                    (selectionChange)="updateEditionName($event?.options?.[0]?.value)">
                    <mat-list-option
                        *ngFor="let name of editionsList()"
                        [value]="name">
                        <div
                            matListItemTitle
                            [dir]="isRTL">
                            {{ name }}
                        </div>
                    </mat-list-option>
                </mat-selection-list>
            </mat-menu>
        </div>

        <div class="st-cast-view-state-body-edition__input">
            <st-text-field
                [value]="editionName$ | ngrxPush"
                [label]="languageSettings.PSTWebPublicationChannelEditionName"
                (changed)="updateEditionName($event)" />
        </div>

        <div class="st-cast-view-state-body-list-title__input">
            <st-text-field
                [value]="publicationListTitle$ | ngrxPush"
                [label]="languageSettings.PSTWebPublicationListTitle"
                (changed)="updatePublicationListTitle($event)" />
        </div>

        <div class="st-cast-view-state-body-tile">
            <div class="st-cast-view-state-body__advanced-settings">
                <span class="st-cast-view-state-body__advanced-settings__label">{{ languageSettings.PSTWebAdvancedSettingsLabel }}</span>
                <st-check-box
                    [value]="viewStateRemoveAddedRecords$ | ngrxPush"
                    [label]="languageSettings.PSTWebPublicationChannelRemoveAddedRecords"
                    (changed)="updateRemoveAddedRecords($event)" />

                @if (publicationTime()) {
                    <st-combo-box
                        [value]="publicationTime()?.Value"
                        [itemList]="publicationTime()?.Options"
                        [shouldHaveFilter]="false"
                        [label]="publicationTime()?.DefaultCaption"
                        (changed)="updatePublicationTime($event)" />
                }
            </div>
        </div>
    </div>
</st-view-state>
